import React from 'react';
import './searchbar.css'
import Search from '../common/searchbtn';
import Input from '../common/searchinput';
const Searchbar = () => {
    return ( <>
    <form className="searchFlex">
        <div className="inputs">
<Input label="price" placeholder="35,000" />
<Input label="price" placeholder="35,000" />
<Input label="price" placeholder="35,000" />

        </div>
<Search />

    </form>
    </> );
}
 
export default Searchbar ;